import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { INotificationDelete, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { deleteNotificationmodel } from '../../flux/actions/notificationmodelActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";

const NotificationDelete = ({
  modal,
  setModal,
  handleToggle,
  modalNotification,
  deleteNotificationmodel,
 }: INotificationDelete) => {
  const [idValue, setIdValue] = useState(-1);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();

  const modalOpenedHandle = () => {
    if(modalNotification && modalNotification !== ''){
      setIdValue(modalNotification["id"]);
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Notification supprimée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const deleteHandle = async () => {
    if(idValue === -1)
      return
    setDisableSubmit(true);
    deleteNotificationmodel(idValue, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp;Supprimer un Notification</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  Voulez-vous vraiment supprimer la notification ?
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-danger linesConfirmationBtn linesDeleteBtn"
                  onClick={deleteHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faTrash} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Supprimer</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default connect(null, { deleteNotificationmodel })(NotificationDelete);
